import {HTTP} from '@/http'
// initial state
const state = {
  dailyFlights: {},
  dailyPayload: [],
  date: '',
  preloader: true
}
// mutations
const mutations = {
  setDailyFlights: function (state, val) {
    state.dailyFlights = val
  },
  setDailyPayload: function (state, val) {
    state.dailyPayload = val
  },
  setPreloaderState: function (state, value) {
    state.preloader = value
  },
  setDate: function (state, date) {
    state.date = date
  }
}
// actions
const actions = {
   async updateDailyFlights (context, params) {
    let access = context.rootGetters.chechAccess('daily')
    if (!access) {
      context.commit('setPreloaderState', false)
      return false
    }
    let d = new Date()
    d.setDate(d.getDate() - 1)
    let defaultParams = {date: this.getters.getFunctions.toSqlFormat(d)}
    params = params || defaultParams
    if (state.date === '') state.date = this.getters.getFunctions.toSqlFormat(d)

    context.commit('setPreloaderState', true)
     await HTTP.post('/api/daily-flights', {
      date: params.date,
      mode: 1
    })
    .then(response => {
      if (response.status === 200) context.commit('setDailyFlights', response.data)
    })
    .catch(e => {
      this.errorMessage = e
      this.dispatch('errorProcess', e)
    })
    context.commit('setPreloaderState', false)
  },
   async updateDailyPayload (context, params) {
    let access = context.rootGetters.chechAccess('daily')
    if (!access) {
      context.commit('setPreloaderState', false)
      return false
    }
    let d = new Date()
    d.setDate(d.getDate() - 1)
    let defaultParams = {date: this.getters.getFunctions.toSqlFormat(d)}
    params = params || defaultParams

    context.commit('setPreloaderState', true)
     await HTTP.post('/api/daily-payload', {
      date: params.date
    })
    .then(response => {
        if (response.status === 200) {
          context.commit('setDailyPayload', response.data)
          context.commit('setPreloaderState', false)
      }
    })
    .catch(e => {
      this.errorMessage = e
      this.dispatch('errorProcess', e)
    })
    context.commit('setPreloaderState', false)

  }
}
// getters
const getters = {
  getDailyFlights (state) {
    return state.dailyFlights
  },
  getDailyPayload (state) {
    return state.dailyPayload
  },
  getPreloader (state) {
    return state.preloader
  },
  getDate (state) {
    return state.date
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
